import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, COMBO_BOX, INPUT_NUMBER, DATE} = FIELD_TYPE;
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "ID",
    name: "id",
    disable: true,
    hide: true,
  },
  {
    type: INPUT,
    label: "Tên đơn vị",
    name: "name",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },

  {
    type: INPUT,
    label: "Số thầu",
    name: "bidCode",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
    rules: [{required: true, message: "Chưa nhập tên số thầu"}],
  },
  {
    type: INPUT,
    label: "Quyết định",
    name: "decision",
    rules: [{required: true, message: "Chưa nhập tên quyết định"}],
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: DATE,
    label: "Ngày công bố",
    name: "announced",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: INPUT,
    label: "Ghi chú",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
    name: "note",
  },
  {
    type: DATE,
    label: "Từ ngày",
    name: "tuNgay",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
    disableDate: false,
  },
  {
    type: DATE,
    label: "Đến ngày",
    name: "denNgay",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
    disableDate: false,
  },
  {
    type: DATE,
    label: "Hạn sở y tế",
    name: "hanSYT",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
    disableDate: false,
  },
  {
    type: INPUT_NUMBER,
    label: "Số lượng",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
    name: "soLuong",
  },
  {
    type: COMBO_BOX,
    label: "Vật tư",
    name: "vtytIds",
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    wrapperCol: {xs: 22, md: 22, xl: 22, lg: 22},
    labelCol: {xs: 2, md: 2, xl: 2, lg: 2},
  },
];
export {dataFields};
